var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#A8DF8E",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 7.66669C15.88 7.66669 7.66663 15.88 7.66663 26C7.66663 36.12 15.88 44.3334 26 44.3334C36.12 44.3334 44.3333 36.12 44.3333 26C44.3333 15.88 36.12 7.66669 26 7.66669ZM33.3883 22.7L24.8266 31.2433C24.5699 31.5183 24.2216 31.6467 23.8549 31.6467C23.5066 31.6467 23.1583 31.5183 22.8833 31.2433L18.6116 26.9717C18.08 26.4401 18.08 25.56 18.6116 25.0283C19.1433 24.4966 20.0233 24.4966 20.555 25.0283L23.8549 28.3284L31.445 20.7567C31.9766 20.2067 32.8566 20.2067 33.3883 20.7567C33.92 21.2884 33.92 22.15 33.3883 22.7Z",
    fill: "#29CC26"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success_tick.2447d9a1cc74f23c7b349e2bd4a5fce8.svg";
export { ForwardRef as ReactComponent };